import React from "react";

import Recognition from "components/recognitions/Recognition";

import UserActivityHeader from "./UserActivityHeader";

const RecognitionCreatedPreview = ({ item, onUserActivityUpdate }) => (
  <Recognition
    recognition={item.entity}
    userActivity={item}
    onUserActivityUpdate={onUserActivityUpdate}
    header={<UserActivityHeader userActivity={item} />}
  />
);

export default RecognitionCreatedPreview;
